module.exports = __webpack_public_path__ + "static/github-f452eb47299be0719f7b086d34e44219.png";